import {gql} from '@apollo/client';

import {getApolloClient} from 'graphql-client/ApolloClient';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const REACTION_COMPONENT_COUNT_QUERY = gql`
  query ReactionComponentCountQuery($reactionId: StrictString!) @skipAudit @engComponent(name: CHEMISTRY) {
    reaction(id: $reactionId) {
      ... on ReactionNode {
        id
        numberOfComponents
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export function setCachedReactionComponentCount(reactionId: string, submittedComponentCount: number): void {
  getApolloClient().writeQuery({
    query: REACTION_COMPONENT_COUNT_QUERY,
    variables: {reactionId},
    data: {
      __typename: 'Query',
      reaction: {
        __typename: 'ReactionNode',
        id: reactionId,
        numberOfComponents: submittedComponentCount,
      },
    },
  });
}

export function clearCachedReactionComponentCount(reactionId: string): void {
  getApolloClient().cache.evict({id: `ReactionNode:${reactionId}`, fieldName: 'numberOfComponents'});
}
